import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { GetProjectFoldersParams, ProjectFoldersGet } from '../project-folders.component';

@Component({
    selector: 'tt-project-folders-view',
    templateUrl: './project-folders-view.component.html',
    styleUrls: ['./project-folders-view.component.css'],
})
export class ProjectFoldersViewComponent {
    public heading = '';

    public params: GetProjectFoldersParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as GetProjectFoldersParams;
    }

    onGetLoaded(get: ProjectFoldersGet) {
        this.heading = get.webpage_heading;
    }
}
